import { LOCAL_DRAFT_KEY_PREFIX } from '@/domain/runner/draft'

/**
 * Remove every browser copy of an exam draft. Called when the session ends (sign-out, an expired session), so the essay a
 * student was typing is not left readable in `localStorage` for the next person at a shared computer (adversarial review
 * #18). Storage can be blocked or absent: nothing here may throw into the sign-out.
 */
export function clearLocalRunnerDrafts(): void {
  try {
    const store = window.localStorage
    const keys: string[] = []
    for (let index = 0; index < store.length; index += 1) {
      const key = store.key(index)
      if (key && key.startsWith(LOCAL_DRAFT_KEY_PREFIX)) keys.push(key)
    }
    for (const key of keys) store.removeItem(key)
  } catch {
    // Storage unavailable: there is no browser copy to remove.
  }
}
